import moment from "moment";
import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import DropdownSelect from "../../components/dropdown/Dropdown";
import DropdownAction from "../../components/dropdown/DropdownAction";
import Table from "../../components/table/Table";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import Checkbox from "../../components/UIComponent/Checkbox";
import FinanceServices from "../../services/axiosServices/apiServices/FinanceServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { getAuthProps } from "../../utils/AuthenticationLibrary";
import { isNullString } from "../../utils/Utils";
import { saveAs } from "file-saver";
import { encryptAES } from "../../utils/Encryption";
import ModalBasic from "../component/FormModal";
import CommonServices from "../../services/axiosServices/apiServices/CommonServices";
import ValidationText from '../../utils/validation/ValidationText';
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../utils/Messages";
export default class AuditCertificateAttendanceUpload extends Component {
    constructor(props) {
        console.log("Props siis : ", props);
        super(props);
        this.financeService = new FinanceServices();
        this.commonServices = new CommonServices();
        this.swalServices = new SwalServices();
        this.state = {
            totalResultes: 0,
            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "",
                orderFlag: 0,
                searchText: "",
                typeOfDocument: "",
                creditNoteStatusId: 0,
                companyName: "",
                companyUEN: "",
            },
            auditList: [],
            itemList: [],
            audidettails: {

                slotsmemberid: 0,
                companyName: "",
                uENNumber: "",
                type: ""
            },

            route: "",

            totalResults: 0,
            selectedIdList: [],
            checkedRow: false,
            checkedHeader: false,
            isRejected: true,
            isApprove: true,
            isLoading: false,
            isApproveCreditNote: false,
            filePath: "",
            comments: "",
            fileDisplayName: "",

        };


    }
    handleChange = (event) => {
        const { name, value } = event.target;
        let detail = this.state.pagination;
        detail[ name ] = value;
        this.setState({ pagination: detail });
        //this.getAllExtractInvoicesList();
    };

    onFileChange = (event) => {

        const file = event.target.files[ 0 ];
        if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
            let request = {};
            request.storagePath = "CreditNoteImages";
            request.file = file;
            request.fileName = file.name;

            this.commonServices.uploadPDF(request).then((response) => {
                if (response != null) {
                    if (request.storagePath === "CreditNoteImages") {
                        let detail = { ...this.state.singleOutstandingInvoiceDetails };
                        detail[ "filePath" ] = response.fileName;
                        detail[ "fileDisplayName" ] = file.name;

                        this.setState({ filePath: response.fileName, fileDisplayName: file.name }, () => {
                            this.swalServices.Success("Image File Uploaded");
                        });
                    }
                } else {
                    this.swalServices.Error(response.message);
                }
            });
        } else {
            this.swalServices.Error("Please select only Image file");
        }
    };

    approveCreditNote = () => {
        this.setState({ isApproveCreditNote: true });
    }


    componentDidMount() {
        this.GetAllAuditCertificateAttendanceUpload();
    }


    GetAllAuditCertificateAttendanceUpload = (pagination = this.state.pagination) => {

        this.setState({ isLoading: true });

        let request = {};
        request.pageNo = pagination.pageNo;
        request.pageSize = pagination.pageSize;
        request.orderByColumn = pagination.orderByColumn;
        request.orderFlag = pagination.orderFlag;
        request.searchText = pagination.searchText;
        request.companyUEN = pagination.companyUEN;
        request.typeOfDocument = pagination.typeOfDocument;
        request.companyName = pagination.companyName;


        this.financeService.GetAllAuditCertificateAttendanceUpload(request).then(
            (response) => {

                if (response.statusCode === 200 && response.responseItem != null) {
                    let details = response.responseItem.responseContent.itemList;
                    details.map((key) => {
                        key.createdAt = key.createdAt ? moment(key.createdAt).format("DD MMM yyyy") : "-";

                        return key;
                    });
                    this.setState({ auditList: details });
                    this.setState({
                        totalResultes: response.responseItem.responseContent.totalCount,
                    });
                } else {
                    this.swalServices.Error(response.message);
                }
                this.setState({ isLoading: false });
            }
        );
    };

    setPagination = (newPagination) => {
        this.setState({ pagination: newPagination });
        this.GetAllAuditCertificateAttendanceUpload(newPagination);
    };

    openApprovalModal = (value) => {

        if (value && value > 0) {

            this.setState({ route: '/AuditCertificatesUpload/slotsSchedulerLogId?=' + encryptAES(value) });

        }
    };

    actions = (element, index, value) => {

        return element !== "slotsSchedulerLogId" ? null : (

            <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap pointer">
                <div class="flex">
                    <div className="flex items-center relative">
                        <button
                            className="action-btn mr-4 flex items-center"
                            aria-controls="add-edit-modal"
                            onClick={() => this.openApprovalModal(value)}
                        >
                            <p className="ml-2 tool-tip-txt underline text-[#005b9c]">Process</p>
                        </button>
                    </div>
                </div>
            </td>
        );
    };

    render() {
        if (this.state.route !== "") {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className="main-body-section finance-body-sec">
                <div className="bg-white pb-2 mt-10">
                    <div className="grid grid-cols-12 gap-6 w-full items-center px-8 pt-10">
                        <div className=" 2xl:col-span-3 lg:col-span-3 col-span-12 w-full">
                            <h2 className="text-xl text-[#000000] font-bold 2xl:mb-1">
                                Company Name
                            </h2>
                            <input
                                id="default"
                                name="companyName"
                                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                                type="text"
                                value={this.state.pagination.companyName}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </div>
                        <div className=" 2xl:col-span-3 lg:col-span-3 col-span-12 w-full">
                            <h2 className="text-xl text-[#000000] font-bold 2xl:mb-1">
                                Company UEN
                            </h2>
                            <input
                                id="default"
                                name="companyUEN"
                                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                                type="text"
                                value={this.state.pagination.companyUEN}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </div>
                        <div className="2xl:col-span-3 lg:col-span-3 col-span-12 w-full">
                            <h2 className="text-xl text-[#000000] font-bold 2xl:mb-1">
                                Type of Document
                            </h2>

                            <select
                                id="default"
                                name="typeOfDocument"
                                className="form-input rounded-none w-full shadow-red py-3 text-lg"
                                value={this.state.pagination.typeOfDocument}
                                onChange={(e) => this.handleChange(e)}
                            >
                                <option value="">Select Document Type</option>
                                <option value="Audit Reminder (18th Month)">
                                    Audit Reminder (18th Month)
                                </option>
                                <option value="Certificate Attendance (9th Month)">
                                    Certificate Attendance (9th Month)
                                </option>
                                <option value="Certificate Attendance (21st Month)">
                                    Certificate Attendance (21st Month)
                                </option>                            
                            </select>
                        </div>

                    </div>
                    <div className="grid grid-cols-12 gap-6 w-full items-end px-8 pb-12">
                        <div className="2xl:col-span-12 lg:col-span-12 col-span-12 w-full">
                            <div className="mt-8 flex items-center justify-end w-full">
                                <button className="btn btn-blue text-xl border text-white "
                                    onClick={() => { this.GetAllAuditCertificateAttendanceUpload() }}
                                >
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Table Section Start */}
                <div className="mt-10 credit-note-approval-table">
                    <Table
                        columns={[
                            { name: "companyName", title: "Company Name" },
                            { name: "UENnumber", title: "Company UEN" },
                            { name: "SchedulerName", title: "Type of Document" },
                            { name: "CreatedAt", title: "Generated Date" },
                            { name: "slotsSchedulerLogId", title: "" },

                        ]}
                        rows={this.state.auditList}
                        isLoading={this.state.isLoading}
                        sortingColumns={[ "companyName", "CreatedAt" ]}
                        pagination={this.state.pagination}
                        totalResultes={this.state.totalResultes}
                        totalCount={this.state.totalResultes}
                        setPagination={this.setPagination.bind(this)}
                        customScope={[
                            {
                                column: "slotsSchedulerLogId",
                                renderTableData: this.actions.bind(this),
                            }
                        ]}
                    />
                </div>
                {/*Table Section End */}


            </div>
        );
    }    
    
}
